(function () {
    // Mobile (≤ 768 px) since 24.09.2026 — only when the Theme Editor switch
    // „Auf dem Handy anzeigen“ is on (data-klc-mobile on the .klc root). Off =
    // bail out before any listener / Crisp loader runs, exactly as before.
    // History: Crisp's client used to go into its own mobile full-screen mode
    // after chat:open and inject inline styles over our hide-CSS — the visitor
    // saw a blank white page. On mobile we therefore never push chat:open and
    // guard Crisp's DOM (crispMobileGuard below).
    var IS_M = false;
    try { IS_M = !!(window.matchMedia && window.matchMedia('(max-width: 768px)').matches); } catch (_) {}
    if (IS_M) {
      var _mRoot = document.querySelector('.klc');
      if (!_mRoot || _mRoot.getAttribute('data-klc-mobile') !== '1') return;
      document.documentElement.classList.add('klc-m');
    }

    var launcher    = document.getElementById('klcLauncher');
    var panel       = document.getElementById('klcPanel');
    var closeBtn    = document.getElementById('klcClose');
    var backdrop    = document.getElementById('klcBackdrop');
    var headerMenu  = document.getElementById('klcHeaderMenu');
    var headerBack  = document.getElementById('klcHeaderBack');
    var headerNew   = document.getElementById('klcHeaderNew');
    var headerHist  = document.getElementById('klcHeaderHistory');
    var headerFull  = document.getElementById('klcHeaderFull');
    var histBadge   = document.getElementById('klcHistoryBadge');
    var chatStream  = document.getElementById('klcChatStream');
    var chatEmpty   = document.getElementById('klcChatEmpty');
    var greetSub    = document.getElementById('klcGreetSub');
    var chatInput   = document.getElementById('klcChatInput');
    var chatSend    = document.getElementById('klcChatSend');
    var chatAttach  = document.getElementById('klcChatAttach');
    var chatFile    = document.getElementById('klcChatFile');
    var chatMic     = document.getElementById('klcChatMic');
    var inputWrap   = chatInput && chatInput.closest('.klc-chat-input-wrap');
    var recBar      = document.getElementById('klcRec');
    var recTime     = document.getElementById('klcRecTime');
    var recCancel   = document.getElementById('klcRecCancel');
    var recSend     = document.getElementById('klcRecSend');
    var lightbox    = document.getElementById('klcLightbox');
    var lightboxImg = document.getElementById('klcLightboxImg');
    var lightboxX   = document.getElementById('klcLightboxClose');
    var histItems   = document.getElementById('klcHistItems');
    var histEmpty   = document.getElementById('klcHistEmpty');
    var histClear   = document.getElementById('klcHistClear');
    var histTrans   = document.getElementById('klcHistTranscript');
    var histStream  = document.getElementById('klcHistStream');
    var histNew     = document.getElementById('klcHistNew');
    var confirmBox  = document.getElementById('klcConfirm');
    var confirmYes  = document.getElementById('klcConfirmYes');
    var confirmNo   = document.getElementById('klcConfirmNo');
    var idCardTpl   = document.getElementById('klcIdCardTpl');
    if (!launcher || !panel) return;

    var CRISP_ID = window.__KLC_CFG.crispId;
    var TOPIC_LABEL = window.__KLC_CFG.topics || {};
    var KLC_I18N = window.__KLC_CFG.i18n || {};
    var KLC_LOCALE = window.__KLC_CFG.locale || 'de';
    // Leer = Anhaenge und Sprachnachrichten sind aus; beide Knoepfe verschwinden.
    var KLC_UPLOAD_URL = window.__KLC_CFG.uploadUrl || '';
    var crispLoaded = false;
    var crispReady  = false;
    var typingEl    = null;
    var hasMessages = false;
    var KLC_DEBUG = false; // set true in console: window.KLC_DEBUG = true

    /* ── Helpers ─────────────────────────────────────────── */
    function fmtTime(ts) {
      try {
        var d = ts ? new Date(ts) : new Date();
        return d.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
      } catch (_) { return ''; }
    }
    function fmtDate(ts) {
      try {
        return new Date(ts).toLocaleString(KLC_LOCALE, { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
      } catch (_) { return fmtTime(ts); }
    }
    function fmtDuration(sec) {
      sec = Math.max(0, Math.round(sec || 0));
      var m = Math.floor(sec / 60), s = sec % 60;
      return m + ':' + (s < 10 ? '0' : '') + s;
    }
    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
      });
    }
    function klcBerlinHour() {
      try {
        var h = new Intl.DateTimeFormat('de-DE', { hour: 'numeric', hour12: false, timeZone: 'Europe/Berlin' }).format(new Date());
        h = parseInt(h, 10);
        if (!isNaN(h)) return h;
      } catch (e) { /* fall through */ }
      return new Date().getHours();
    }

    /* ── Wiedererkennung (Händlerwunsch 24.09.2026) ─────────────
       Crisp hält eine Sitzung per Cookie 6 Monate (Sitzungen mit Nachrichten
       bleiben dauerhaft) — auf demselben Gerät geht das Gespräch also weiter.
       Diese lokale Notiz merkt sich zusätzlich, welche Crisp-Sitzungen der
       Besucher hatte und wann zuletzt geschrieben wurde: Grundlage für
       „Willkommen zurück", die Ein-Klick-Bestätigung nach verlorener Sitzung
       (Safari löscht Skript-Speicher nach 7 Tagen) und den Hinweis in Crisp.
       Nur auf diesem Gerät; an Crisp gehen nur Anzahl + Datum (pushVisitorFacts). */
    var VISITOR_KEY = 'klc_visitor';
    var VISITOR_MAX = 20;
    var VISITOR_TTL = 180 * 864e5;
    var RETURN_GAP  = 30 * 60e3;
    function _readVisitor() {
      try {
        var o = JSON.parse(localStorage.getItem(VISITOR_KEY) || '{}');
        return (o && typeof o === 'object' && !Array.isArray(o)) ? o : {};
      } catch (e) { return {}; }
    }
    // klc_identity (Name + E-Mail aus der Karte) gilt 180 Tage ab dem letzten
    // Speichern, danach wird es entfernt (02.10.2026, Datenschutzerklaerung
    // Ziffer 15/22). Eintraege ohne Zeitstempel (vor diesem Datum) gelten ab jetzt.
    var KLC_ID_TTL = 180 * 24 * 60 * 60 * 1000;
    function _readIdentity() {
      try {
        var o = JSON.parse(localStorage.getItem('klc_identity') || 'null');
        if (!o || !o.email) return null;
        if (!o.ts) { o.ts = Date.now(); localStorage.setItem('klc_identity', JSON.stringify(o)); }
        if (Date.now() - o.ts > KLC_ID_TTL) { localStorage.removeItem('klc_identity'); return null; }
        return o;
      } catch (e) { return null; }
    }
    function _knownIdentity() {
      var o = _readIdentity();
      return o ? { email: String(o.email), name: String(o.name || '') } : null;
    }
    var _visitorAtLoad = _readVisitor();
    var _idAtLoad = _knownIdentity();
    var _visitorPushed = false;
    function _noteActivity(ts) {
      var sid = crispSessionId();
      if (!sid) return;
      ts = Number(ts) || Date.now();
      var o = _readVisitor(), now = Date.now();
      if ((Number(o[sid]) || 0) >= ts) return;
      o[sid] = ts;
      var out = {};
      Object.keys(o).filter(function (k) { return now - (Number(o[k]) || 0) < VISITOR_TTL; })
        .sort(function (a, b) { return o[b] - o[a]; })
        .slice(0, VISITOR_MAX)
        .forEach(function (k) { out[k] = o[k]; });
      try { localStorage.setItem(VISITOR_KEY, JSON.stringify(out)); } catch (e) {}
    }
    function visitorFacts() {
      var sid = crispSessionId(), now = Date.now(), prev = 0, last = 0;
      Object.keys(_visitorAtLoad).forEach(function (k) {
        var t = Number(_visitorAtLoad[k]) || 0;
        if (!t || now - t > VISITOR_TTL) return;
        if (k !== sid) prev++;
        if (t > last) last = t;
      });
      // Rückkehrer: frühere Sitzung, oder dieselbe nach >30 min Pause, oder (ohne Zeitstempel) schon einmal ausgewiesen.
      var returning = prev > 0 || (last ? now - last > RETURN_GAP : !!_idAtLoad);
      return { returning: !!returning, prev: prev, last: last };
    }
    function fmtBerlin(ts) {
      try {
        var parts = {};
        new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false })
          .formatToParts(new Date(ts)).forEach(function (p) { parts[p.type] = p.value; });
        return parts.year + '-' + parts.month + '-' + parts.day + ' ' + parts.hour + ':' + parts.minute;
      } catch (e) { return new Date(ts).toISOString().slice(0, 16).replace('T', ' '); }
    }
    /* Hinweis für die Händlerin in Crisp: Rückkehrer, frühere Gespräche, letzter Kontakt. */
    function pushVisitorFacts() {
      var f = visitorFacts();
      if (!f.returning) return;
      var data = [['returning_visitor', 'yes'], ['previous_conversations', String(f.prev)]];
      if (f.last) data.push(['last_contact', fmtBerlin(f.last)]);
      crispPush(['set', 'session:data', [data]]);
      if (!_visitorPushed) crispPush(['set', 'session:segments', [['returning'], false]]);
      _visitorPushed = true;
    }
    (function () {
      var el = document.getElementById('klcGreetBack');
      if (!el || !_idAtLoad || !_idAtLoad.name || !KLC_I18N.welcomeBack) return;
      el.textContent = KLC_I18N.welcomeBack.replace('{name}', _idAtLoad.name.split(' ')[0]);
      el.hidden = false;
    })();
    /* "Our team usually replies within minutes" is only true inside the
       staffed window (Mo–So 08–23 Berlin, CLAUDE.md §9.23) — outside it the
       line is dropped rather than promising what nobody can keep. */
    var cardHour = klcBerlinHour();
    if (greetSub && !(cardHour >= 8 && cardHour < 23)) greetSub.hidden = true;

    /* ── Thread bubbles ───────────────────────────────────── */
    /* In-memory copy of what the thread shows, in order — the source for the
       history snapshot when a new conversation starts (see klcHistory). Kept
       separate from the DOM so we never have to parse bubbles back. */
    var _transcript = [];
    /* The welcome area is no longer removed when the conversation starts: its
       wordmark + product card stay on top as the thread's header, "Hallo …" and
       the quick actions fold away (CSS .is-started), and messages flow from the
       top instead of sitting at the bottom of an empty field. */
    function _startThread() {
      if (chatEmpty) chatEmpty.classList.add('is-started');
      if (chatStream) chatStream.classList.add('is-started');
    }
    function _onFirstMessage() {
      if (!hasMessages) { _startThread(); hasMessages = true; }
      updateHistoryBadge();
    }
    function _timeEl(ts) {
      var time = document.createElement('span');
      time.className = 'klc-msg__time';
      time.textContent = fmtTime(ts);
      return time;
    }
    function _mount(div) {
      chatStream.appendChild(div);
      chatStream.scrollTop = chatStream.scrollHeight;
      scheduleWait();
    }
    function appendMessage(from, text, ts, extraClass) {
      if (!chatStream) return null;
      _onFirstMessage();
      removeTyping();
      var div = document.createElement('div');
      div.className = 'klc-msg klc-msg--' + from + (extraClass ? ' ' + extraClass : '');
      div.innerHTML = escapeHtml(text || '') +
        '<span class="klc-msg__time">' + fmtTime(ts) + '</span>';
      _mount(div);
      _transcript.push({ from: from, type: 'text', text: String(text || ''), ts: ts || Date.now() });
      return div;
    }
    function appendImage(from, src, ts) {
      if (!chatStream) return null;
      _onFirstMessage();
      removeTyping();
      var div = document.createElement('div');
      div.className = 'klc-msg klc-msg--' + from + ' klc-msg--image';
      var img = document.createElement('img');
      img.alt = KLC_I18N.attach || '';
      img.loading = 'lazy';
      img.src = src;
      img.addEventListener('click', function () { openLightbox(img.src); });
      div.appendChild(img);
      div.appendChild(_timeEl(ts));
      _mount(div);
      div._klcEntry = { from: from, type: 'image', url: src, ts: ts || Date.now() };
      _transcript.push(div._klcEntry);
      return div;
    }
    function appendVideo(from, src, ts) {
      if (!chatStream) return null;
      _onFirstMessage();
      removeTyping();
      var div = document.createElement('div');
      div.className = 'klc-msg klc-msg--' + from + ' klc-msg--video';
      var v = document.createElement('video');
      v.src = src;
      v.controls = true;
      v.playsInline = true;
      v.preload = 'metadata';
      div.appendChild(v);
      div.appendChild(_timeEl(ts));
      _mount(div);
      div._klcEntry = { from: from, type: 'video', url: src, ts: ts || Date.now() };
      _transcript.push(div._klcEntry);
      return div;
    }
    function appendAudio(from, src, ts, duration) {
      if (!chatStream) return null;
      _onFirstMessage();
      removeTyping();
      var div = document.createElement('div');
      div.className = 'klc-msg klc-msg--' + from + ' klc-msg--audio';
      var label = document.createElement('span');
      label.className = 'klc-msg__label';
      label.textContent = (KLC_I18N.audioLabel || '') + (duration ? ' · ' + fmtDuration(duration) : '');
      div.appendChild(label);
      var a = document.createElement('audio');
      a.src = src;
      a.controls = true;
      a.preload = 'metadata';
      div.appendChild(a);
      div.appendChild(_timeEl(ts));
      _mount(div);
      div._klcEntry = { from: from, type: 'audio', url: src, duration: duration || 0, ts: ts || Date.now() };
      _transcript.push(div._klcEntry);
      return div;
    }
    /* A note from the widget itself (e.g. microphone denied) — centred,
       never a bubble, never in the transcript: it is not part of the chat. */
    function appendSystemNote(text) {
      if (!chatStream || !text) return;
      var p = document.createElement('p');
      p.className = 'klc-sys';
      p.textContent = text;
      _mount(p);
      setTimeout(function () { if (p.parentNode) p.parentNode.removeChild(p); }, 8000);
    }

    /* ── Antwortversprechen (Händlerwunsch 24.09.2026) ────────────
       An der Blase stand immer „Antwort in ca. 2 Min." – auch für jemanden,
       der längst wartet. Die Stufe wird aus dem Verlauf abgeleitet:
         0  = nichts offen, oder innerhalb 08–23 Uhr noch keine 2 Minuten;
         6  = eine offene Runde seit ≥ 2 min (außerhalb 08–23 Uhr sofort);
         24 = der Besucher kam wieder (Lücke ≥ RETURN_GAP) und schrieb erneut,
              immer noch ohne Antwort.
       Jede menschliche Antwort setzt auf 0 zurück; automatische Crisp-
       Nachrichten (Bot, Trigger, Kampagne) zählen nicht als Antwort.
       klc_wait trägt die Stufe über den Seitenwechsel, bis Crisp geladen ist. */
    var WAIT_KEY      = 'klc_wait';
    var WAIT_FIRST_MS = 2 * 60e3;
    var WAIT_TTL      = 7 * 864e5;
    var waitEl = null, _waitTimer = null, _waitSched = null;
    var _autoTs = {};
    var teaserSub = document.getElementById('klcTeaserSub');
    var cardSub   = document.getElementById('klcCardSub');
    var _teaserDefault = teaserSub ? teaserSub.textContent : '';
    var _cardDefault   = cardSub ? cardSub.textContent : '';
    function _isAutoMsg(msg) {
      if (msg.automated) return true;
      return /bot|trigger|campaign/i.test(String(msg.origin || ''));
    }
    function waitLevel() {
      // By position, not timestamp: local sends carry the device clock, Crisp's
      // echoes the server clock — the thread order is the arrival order.
      var open = [];
      _transcript.forEach(function (e) {
        if (e.from === 'user') open.push(Number(e.ts) || Date.now());
        else if (!_autoTs[e.ts]) open = [];
      });
      if (!open.length) return { h: 0 };
      open.sort(function (a, b) { return a - b; });
      var rounds = 1;
      for (var i = 1; i < open.length; i++) if (open[i] - open[i - 1] >= RETURN_GAP) rounds++;
      if (rounds >= 2) return { h: 24 };
      var hr = klcBerlinHour(), waited = Date.now() - open[0];
      if (hr >= 8 && hr < 23 && waited < WAIT_FIRST_MS) return { h: 0, recheck: WAIT_FIRST_MS - waited + 500 };
      return { h: 6 };
    }
    function _storeWait(h) {
      try {
        if (h) localStorage.setItem(WAIT_KEY, JSON.stringify({ h: h, ts: Date.now() }));
        else localStorage.removeItem(WAIT_KEY);
      } catch (e) {}
    }
    function applyWait(h, bubbleOnly) {
      var short = h ? String(KLC_I18N.waitShort || '').replace('{h}', h) : '';
      if (teaserSub) teaserSub.textContent = short || _teaserDefault;
      if (cardSub) cardSub.textContent = short || _cardDefault;
      if (bubbleOnly || !chatStream) return;
      if (!h || !KLC_I18N.waitLine) {
        if (waitEl && waitEl.parentNode) waitEl.parentNode.removeChild(waitEl);
        return;
      }
      if (!waitEl) {
        waitEl = document.createElement('p');
        waitEl.className = 'klc-wait';
        waitEl.id = 'klcWait';
        waitEl.setAttribute('role', 'status');
      }
      waitEl.textContent = String(KLC_I18N.waitLine).replace('{h}', h);
      if (chatStream.lastChild !== waitEl) {
        chatStream.appendChild(waitEl);
        chatStream.scrollTop = chatStream.scrollHeight;
      }
    }
    function renderWait() {
      _waitSched = null;
      if (_waitTimer) { clearTimeout(_waitTimer); _waitTimer = null; }
      var lvl = waitLevel();
      if (lvl.recheck) _waitTimer = setTimeout(renderWait, lvl.recheck);
      applyWait(lvl.h);
      _storeWait(lvl.h);
    }
    /* Deferred: the append helpers push to _transcript after _mount, and a
       hydration run appends many messages in one go — render once after. */
    function scheduleWait() {
      if (!_waitSched) _waitSched = setTimeout(renderWait, 0);
    }
    function resetWait() {
      if (_waitTimer) { clearTimeout(_waitTimer); _waitTimer = null; }
      _autoTs = {};
      applyWait(0);
      _storeWait(0);
    }
    (function () {
      try {
        var o = JSON.parse(localStorage.getItem(WAIT_KEY) || 'null');
        if (o && (o.h === 6 || o.h === 24) && Date.now() - (Number(o.ts) || 0) < WAIT_TTL) applyWait(o.h, true);
        else if (o) localStorage.removeItem(WAIT_KEY);
      } catch (e) {}
    })();
    function markFailed(bubble) {
      if (!bubble) return;
      bubble.classList.remove('klc-msg--uploading');
      bubble.classList.add('klc-msg--failed');
      var f = document.createElement('span');
      f.className = 'klc-msg__fail';
      f.textContent = KLC_I18N.uploadFailed || '';
      bubble.appendChild(f);
    }

    function openLightbox(src) {
      if (!lightbox || !lightboxImg) return;
      lightboxImg.src = src;
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
    }
    function closeLightbox() {
      if (!lightbox) return;
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
    }
    var typingTimer = null;
    function showTyping() {
      // Never under the greeting + quick actions: Crisp fires compose
      // events as soon as an operator opens the session in the dashboard,
      // before the visitor has said a word. Show only once the thread
      // holds at least one message (hasMessages is set in _onFirstMessage).
      if (!chatStream || !hasMessages) return;
      if (!typingEl) {
        typingEl = document.createElement('div');
        typingEl.className = 'klc-typing-row';
        typingEl.innerHTML =
          '<span class="klc-typing-avatar" aria-hidden="true">K</span>' +
          '<span class="klc-typing-body">' +
            '<span class="klc-typing-name">' + escapeHtml(KLC_I18N.typing || '…') + '</span>' +
            '<span class="klc-typing"><span></span><span></span><span></span></span>' +
          '</span>';
        chatStream.appendChild(typingEl);
        chatStream.scrollTop = chatStream.scrollHeight;
      }
      // Crisp emits compose events repeatedly while the operator types
      // and has no reliable "stopped" event — auto-hide after a pause.
      if (typingTimer) clearTimeout(typingTimer);
      typingTimer = setTimeout(removeTyping, 5000);
    }
    function removeTyping() {
      if (typingTimer) { clearTimeout(typingTimer); typingTimer = null; }
      if (typingEl) { typingEl.remove(); typingEl = null; }
    }

    /* ── Incoming messages (event + poll), both directions ─── */
    var _seenFingerprints = {};
    function _isSeen(fp) {
      if (!fp) return false;
      if (_seenFingerprints[fp]) return true;
      _seenFingerprints[fp] = true;
      return false;
    }
    /* Messages we appended locally the moment they were sent. When Crisp
       echoes them back (event or poll) they must not render a second time —
       but after a page change the same call is exactly what rebuilds the
       thread, so "from: user" is never thrown away. Text: matched by content
       within 60 s. Files/audio: matched by the uploaded URL. */
    var _pendingOwn   = [];
    var _ownFileUrls  = {};
    function _noteOwnText(text) { _pendingOwn.push({ text: String(text || '').trim(), ts: Date.now() }); }
    function _noteOwnFile(url, bubble) {
      if (url) _ownFileUrls[url] = true;
      if (bubble && bubble._klcEntry && url) bubble._klcEntry.url = url;
    }
    function _isOwnEcho(msg, type, text) {
      if (type === 'file' || type === 'audio') {
        return !!(msg.content && msg.content.url && _ownFileUrls[msg.content.url]);
      }
      var now = Date.now(), t = String(text || '').trim();
      for (var i = _pendingOwn.length - 1; i >= 0; i--) {
        if (now - _pendingOwn[i].ts > 60000) { _pendingOwn.splice(i, 1); continue; }
        if (_pendingOwn[i].text === t) { _pendingOwn.splice(i, 1); return true; }
      }
      return false;
    }
    function _handleMessage(msg) {
      if (!msg) return;
      _noteActivity(msg.timestamp);
      var from = (msg.from || msg.user && msg.user.type || '').toString().toLowerCase();
      var own  = (from === 'user' || from === 'visitor');
      var side = own ? 'user' : 'agent';
      // The operator's message has landed — drop the typing indicator.
      if (!own) removeTyping();
      var type = (msg.type || '').toLowerCase();
      var content = (typeof msg.content === 'string') ? msg.content
                  : (msg.content && msg.content.text) ? msg.content.text
                  : '';
      if (own && _isOwnEcho(msg, type, content)) { _isSeen(msg.fingerprint); return; }
      // De-dupe via Crisp fingerprint
      if (_isSeen(msg.fingerprint)) return;
      if (KLC_DEBUG) console.log('[KLC] message', side, msg);
      if (!own && _isAutoMsg(msg) && msg.timestamp) _autoTs[msg.timestamp] = true;
      if (type === 'audio' && msg.content && msg.content.url) {
        appendAudio(side, msg.content.url, msg.timestamp, msg.content.duration);
        return;
      }
      if (type === 'file' && msg.content && msg.content.url) {
        var t = (msg.content.type || '').toLowerCase();
        if (t.indexOf('video') === 0)      appendVideo(side, msg.content.url, msg.timestamp);
        else if (t.indexOf('audio') === 0) appendAudio(side, msg.content.url, msg.timestamp, 0);
        else                               appendImage(side, msg.content.url, msg.timestamp);
        return;
      }
      if (!content) return;
      var isCtx = own && KLC_I18N.ctxHeader && content.indexOf(KLC_I18N.ctxHeader) === 0;
      appendMessage(side, content, msg.timestamp, isCtx ? 'klc-msg--ctx' : '');
    }
    /* Rebuild the thread from Crisp's own copy of the session (undocumented
       getter, in production use here since months; failure = the old
       behaviour). Sorted by timestamp because the array order is not
       guaranteed. */
    function hydrateFromCrisp() {
      if (!window.$crisp || typeof window.$crisp.get !== 'function') return;
      try {
        var messages = window.$crisp.get('chat:messages');
        if (!Array.isArray(messages) || !messages.length) return;
        messages.slice().sort(function (a, b) { return (a.timestamp || 0) - (b.timestamp || 0); })
                .forEach(_handleMessage);
      } catch (e) {
        if (KLC_DEBUG) console.warn('[KLC] hydrate failed', e);
      }
    }
    var _pollTimer = null;
    function _startPollingFallback() {
      if (_pollTimer) return;
      _pollTimer = setInterval(function () {
        if (!window.$crisp || !window.$crisp.get) return;
        try {
          var messages = window.$crisp.get('chat:messages');
          if (!Array.isArray(messages)) return;
          messages.forEach(_handleMessage);
        } catch (e) {
          if (KLC_DEBUG) console.warn('[KLC] poll failed', e);
        }
      }, 3500);
    }

    /* ── Crisp loader (silent — UI hidden via CSS) ───────── */
    function loadCrisp(cb) {
      if (crispLoaded) { cb && cb(); return; }
      crispLoaded = true;
      /* The page-feedback widget (sections/product-feedback.liquid) may have
         booted Crisp already. Never reassign an existing $crisp — after l.js
         loads it is the live SDK object, and replacing it with [] would kill
         the session. Reuse queue + ID when present. */
      if (!window.$crisp) window.$crisp = [];
      if (!window.CRISP_WEBSITE_ID) window.CRISP_WEBSITE_ID = CRISP_ID;
      window.$crisp.push(['safe', true]);
      window.$crisp.push(['on', 'message:received', _handleMessage]);
      // Operator typing indicator. Crisp's documented event is
      // 'message:compose:received'; keep the older composer:* names as
      // a fallback for other SDK versions. showTyping() self-expires and
      // is a no-op while the thread is still empty.
      window.$crisp.push(['on', 'message:compose:received', function () { showTyping(); }]);
      window.$crisp.push(['on', 'message:composer:started', function () { showTyping(); }]);
      window.$crisp.push(['on', 'message:composer:stopped', function () { removeTyping(); }]);
      window.$crisp.push(['on', 'session:loaded', function () {
        if (KLC_DEBUG) console.log('[KLC] crisp session:loaded');
        // Re-register receive after session is loaded (defensive)
        try { window.$crisp.push(['on', 'message:received', _handleMessage]); } catch (_) {}
        // Rebuild the thread from the session (page change / returning visitor)
        hydrateFromCrisp();
      }]);
      function afterLoad() {
        crispReady = true;
        if (KLC_DEBUG) console.log('[KLC] crisp script loaded');
        // Desktop: chat:open keeps message:received flowing (ADR-003). Mobile:
        // never — it switches Crisp into its full-screen chatbox; the 3.5 s
        // chat:messages poll below delivers replies instead.
        if (!IS_M) { try { window.$crisp.push(['do', 'chat:open']); } catch (_) {} }
        else crispMobileGuard();
        hydrateFromCrisp();
        // Polling fallback in case events don't fire reliably
        _startPollingFallback();
        cb && cb();
      }
      /* l.js may already be in the DOM (booted by the feedback widget) —
         don't inject twice. If the SDK is live ($crisp is no longer a plain
         queue array), run the post-load steps now; else wait for its load. */
      var existing = document.querySelector('script[src*="client.crisp.chat/l.js"]');
      if (existing) {
        if (window.$crisp && !Array.isArray(window.$crisp)) { afterLoad(); }
        else { existing.addEventListener('load', afterLoad); }
        return;
      }
      var s = document.createElement('script');
      s.src = 'https://client.crisp.chat/l.js';
      s.async = 1;
      s.onload = afterLoad;
      document.head.appendChild(s);
    }
    /* Mobile guard: whatever Crisp writes inline onto its own container is put
       back off-screen, and a body pinned with position:fixed (its old scroll
       lock) is released. html/body overflow is left alone on purpose — the
       theme's own dialogs lock scrolling that way (§9.14). */
    var _crispGuardOn = false;
    function crispMobileGuard() {
      if (_crispGuardOn || !window.MutationObserver) return;
      _crispGuardOn = true;
      var OFF = { position: 'fixed', left: '-10000px', top: '-10000px', width: '1px', height: '1px', opacity: '0', 'pointer-events': 'none', 'z-index': '-1' };
      function fixBox(el) {
        for (var k in OFF) {
          if (el.style.getPropertyValue(k) !== OFF[k] || el.style.getPropertyPriority(k) !== 'important') {
            el.style.setProperty(k, OFF[k], 'important');
          }
        }
      }
      function fixBody() {
        var b = document.body;
        if (b && b.style.position === 'fixed') {
          b.style.removeProperty('position');
          b.style.removeProperty('top');
          b.style.removeProperty('left');
          b.style.removeProperty('right');
          b.style.removeProperty('width');
        }
      }
      function sweep() {
        var boxes = document.querySelectorAll('.crisp-client, #crisp-chatbox');
        for (var i = 0; i < boxes.length; i++) fixBox(boxes[i]);
        fixBody();
      }
      sweep();
      new MutationObserver(sweep).observe(document.body, { childList: true });
      new MutationObserver(function (list) {
        for (var i = 0; i < list.length; i++) {
          var t = list[i].target;
          if (t === document.body) fixBody();
          else if (t.nodeType === 1 && (t.id === 'crisp-chatbox' || (t.classList && t.classList.contains('crisp-client')))) fixBox(t);
        }
      }).observe(document.documentElement, { attributes: true, attributeFilter: ['style'], subtree: true });
    }

    function crispPush(arr) {
      loadCrisp(function () {
        var tries = 0;
        (function go() {
          if (window.$crisp && window.$crisp.push) {
            try { window.$crisp.push(arr); } catch (e) { console.warn('Crisp push failed', e); }
          } else if (tries++ < 60) {
            setTimeout(go, 100);
          }
        })();
      });
    }

    /* ── Context (what the operator sees) ─────────────────── */
    function getDeviceType() {
      var ua = navigator.userAgent || '';
      if (/Mobi|Android|iPhone|iPad/.test(ua)) return /iPad|Tablet/.test(ua) ? 'tablet' : 'mobile';
      return 'desktop';
    }
    var klcRoot = launcher.parentNode; // the .klc wrapper
    var klcContext = {
      topic: '', topicLabel: '', email: '', name: '', orderNumber: '', hasOrder: '',
      software: (klcRoot.getAttribute('data-klc-product') || '').trim(),
      platform: (klcRoot.getAttribute('data-klc-platform') || '').trim()
    };
    /* Remember the last product seen so a chat opened from the homepage still
       tells the operator what the visitor was looking at. */
    /* Produktleiste (23.09.2026): auf PDPs zeigt #klcProd Bild + Name. Das X nimmt das
       Produkt aus dem Kontext (Besucherentscheid: es geht nicht um dieses Produkt) und
       merkt sich das je Produkt für die Sitzung (klc_prod_hidden = Handle). */
    var PROD_HIDDEN_KEY = 'klc_prod_hidden';
    var prodBar = document.getElementById('klcProd');
    var prodKey = prodBar ? (prodBar.getAttribute('data-klc-prod-key') || '') : '';
    var prodDismissed = false;
    try {
      var hid = sessionStorage.getItem(PROD_HIDDEN_KEY) || '';
      // Auf der Seite des weggeklickten Produkts bleibt es weg; auf einer anderen PDP
      // erscheint die neue Leiste wieder. Ohne Leiste (keine PDP) gilt: in dieser Sitzung
      // wurde ein Produkt abgewählt → kein Rückfall auf klc_last_product.
      if (hid && (!prodKey || hid === prodKey)) prodDismissed = true;
    } catch (e) {}
    if (prodDismissed) { klcContext.software = ''; klcContext.platform = ''; if (prodBar) prodBar.hidden = true; }
    var prodX = document.getElementById('klcProdX');
    if (prodX && prodBar) prodX.addEventListener('click', function () {
      prodBar.hidden = true;
      prodDismissed = true;
      klcContext.software = ''; klcContext.platform = ''; klcContext.productUrl = '';
      try { sessionStorage.setItem(PROD_HIDDEN_KEY, prodKey || '1'); } catch (e) {}
      renderPickers();
      var pi = pickHost && pickHost.querySelector('.klc-pick__open');
      if (pi) pi.focus(); else if (chatInput) chatInput.focus();
    });
    /* Auf Produktseiten: letzter Stand für „Zuletzt angesehen“ im Produktwähler.
       Außerhalb geht das zuletzt angesehene Produkt NICHT mehr still als „Produkt“
       an Crisp (der Besucher wählt es selbst) — nur als Hinweis last_viewed_product. */
    var RECENT_KEY = 'klc_recent_products';
    function _readRecent() {
      try { var a = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; }
    }
    /* Datenschutz (02.10.2026): die Liste wird nur mit dem Schalter
       „Zuletzt angesehene Produkte“ im Cookie-Hinweis geschrieben (kxConsent);
       ohne ihn entfernt snippets/scripts.liquid vorhandene Einträge. */
    function _rvAllowed() {
      try { return !!(window.kxConsent && window.kxConsent.service('other.recently_viewed')); } catch (e) { return false; }
    }
    (function () {
      try {
        if (prodBar && klcContext.software && _rvAllowed()) {
          var u = klcRoot.getAttribute('data-klc-product-url') || '';
          var entry = { t: klcContext.software, u: u, i: klcRoot.getAttribute('data-klc-product-img') || '' };
          var list = _readRecent().filter(function (r) { return r && r.u !== u; });
          list.unshift(entry);
          localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 3)));
          localStorage.setItem('klc_last_product', klcContext.software);
          if (klcContext.platform) localStorage.setItem('klc_last_platform', klcContext.platform);
        } else if (!prodBar) {
          klcContext.lastViewed = (localStorage.getItem('klc_last_product') || '').trim();
        }
      } catch (e) {}
    })();

    /* ── Produktwähler (Händlerwunsch 24.09.2026) ─────────────────
       Ohne Produktseite (oder nach dem X) sucht der Besucher sein Produkt selbst:
       im Begrüßungsbereich (#klcPick) und optional in der Identitätskarte. Beide
       Stellen zeigen denselben Stand (_picked). Quelle ist Shopifys eigene
       Vorschlagssuche {root}search/suggest.json — sprachrichtig, keine Drittanbieter.
       Auswahl bleibt für die Sitzung (klc_pick). */
    var PICK_KEY = 'klc_pick';
    var pickHost = document.getElementById('klcPick');
    var _pickHosts = [];
    var _picked = null;
    try { var pk = JSON.parse(sessionStorage.getItem(PICK_KEY) || 'null'); if (pk && pk.t) _picked = pk; } catch (e) {}
    function _pdpProductActive() { return !!(prodBar && !prodDismissed); }
    function _applyPickToContext() {
      if (_pdpProductActive()) return;
      klcContext.software = _picked ? _picked.t : '';
      klcContext.productUrl = _picked ? _picked.u : '';
      klcContext.platform = _picked ? (/\bmac\b/i.test(_picked.t) ? 'Mac' : '') : '';
    }
    _applyPickToContext();
    function _absUrl(u) {
      u = String(u || '').split('?')[0];
      if (!u) return '';
      return /^https?:/i.test(u) ? u : window.location.origin + (u.charAt(0) === '/' ? u : '/' + u);
    }
    function _imgUrl(u, w) {
      if (!u) return '';
      return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + (w || 96);
    }
    function _fmtPrice(p) {
      var n = parseFloat(p);
      if (isNaN(n)) return '';
      var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      try { return new Intl.NumberFormat(KLC_LOCALE, { style: 'currency', currency: cur }).format(n); }
      catch (e) { return n.toFixed(2) + ' ' + cur; }
    }
    function _svg(path, size) {
      return '<svg width="' + (size || 16) + '" height="' + (size || 16) + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + path + '</svg>';
    }
    var ICO_SEARCH = '<circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>';
    var ICO_X = '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>';
    var ICO_BOX = '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/>';
    /* Hervorhebung des Suchbegriffs — erst escapen, dann markieren. */
    function _mark(title, q) {
      var t = escapeHtml(title || '');
      var words = String(q || '').trim().split(/\s+/).filter(function (w) { return w.length > 1; });
      words.forEach(function (w) {
        var re = new RegExp('(' + escapeHtml(w).replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
        t = t.replace(re, '<mark>$1</mark>');
      });
      return t;
    }
    function selectPicked(item) {
      _picked = item ? { t: item.t, u: _absUrl(item.u), i: item.i || '', p: item.p || '' } : null;
      try { if (_picked) sessionStorage.setItem(PICK_KEY, JSON.stringify(_picked)); else sessionStorage.removeItem(PICK_KEY); } catch (e) {}
      _applyPickToContext();
      renderPickers();
      /* Kontext ging schon an Crisp (Identität in diesem Gespräch erledigt): das Produkt
         nachreichen — als Sitzungsdaten immer, als Kontextblase nur bei laufendem Gespräch. */
      if (_picked && identityDone()) {
        crispPush(['set', 'session:data', [[['software', _picked.t], ['product_url', _picked.u]]]]);
      }
      if (_picked && hasMessages && identityDone()) {
        var text = KLC_I18N.ctxHeader + '\n' + KLC_I18N.ctxSoftware + ': ' + _picked.t + '\n' + _picked.u;
        _noteOwnText(text);
        appendMessage('user', text, Date.now(), 'klc-msg--ctx');
        crispPush(['do', 'message:send', ['text', text]]);
      }
    }
    function _selectedCard(onClear) {
      var d = document.createElement('div');
      d.className = 'klc-prod klc-pick__sel';
      d.innerHTML =
        '<span class="klc-prod__img">' + (_picked.i ? '<img src="' + escapeHtml(_imgUrl(_picked.i, 96)) + '" alt="" width="40" height="40" loading="lazy">' : _svg(ICO_BOX, 18)) + '</span>' +
        '<span class="klc-prod__name">' + escapeHtml(_picked.t) + '</span>' +
        '<button type="button" class="klc-prod__x" aria-label="' + escapeHtml(KLC_I18N.prodRemove || '') + '" title="' + escapeHtml(KLC_I18N.prodRemove || '') + '">' + _svg(ICO_X, 13) + '</button>';
      d.querySelector('.klc-prod__x').addEventListener('click', onClear);
      return d;
    }
    /* Ein Suchfeld mit Vorschlagsliste (WAI-ARIA combobox). */
    function _searchBox(host, autoFocus) {
      var uid = 'klcPick' + Math.random().toString(36).slice(2, 8);
      var wrap = document.createElement('div');
      wrap.className = 'klc-pick__box';
      wrap.innerHTML =
        '<div class="klc-pick__field">' + _svg(ICO_SEARCH, 16) +
          '<input type="search" class="klc-pick__input" role="combobox" aria-autocomplete="list" aria-expanded="false" aria-controls="' + uid + '" autocomplete="off" spellcheck="false" maxlength="80" placeholder="' + escapeHtml(KLC_I18N.pickPh || '') + '" aria-label="' + escapeHtml(KLC_I18N.pickLabel || '') + '">' +
          '<span class="klc-pick__spin" aria-hidden="true" hidden></span>' +
        '</div>' +
        '<ul class="klc-pick__list" id="' + uid + '" role="listbox" hidden></ul>';
      var input = wrap.querySelector('input');
      var list = wrap.querySelector('ul');
      var spin = wrap.querySelector('.klc-pick__spin');
      var items = [], active = -1, timer = null, seq = 0, ctrl = null;
      function close() { list.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); active = -1; }
      function setActive(i) {
        var opts = list.querySelectorAll('.klc-pick__opt');
        if (!opts.length) return;
        active = (i + opts.length) % opts.length;
        Array.prototype.forEach.call(opts, function (o, k) { o.classList.toggle('is-active', k === active); o.setAttribute('aria-selected', k === active ? 'true' : 'false'); });
        input.setAttribute('aria-activedescendant', opts[active].id);
        opts[active].scrollIntoView({ block: 'nearest' });
      }
      function draw(rows, q, heading) {
        items = rows;
        list.innerHTML = '';
        if (heading) {
          var h = document.createElement('li');
          h.className = 'klc-pick__head'; h.setAttribute('role', 'presentation'); h.textContent = heading;
          list.appendChild(h);
        }
        if (!rows.length) {
          var n = document.createElement('li');
          n.className = 'klc-pick__none'; n.setAttribute('role', 'presentation'); n.textContent = KLC_I18N.pickNone || '';
          list.appendChild(n);
        }
        rows.forEach(function (r, k) {
          var li = document.createElement('li');
          li.className = 'klc-pick__opt'; li.id = uid + '-' + k;
          li.setAttribute('role', 'option'); li.setAttribute('aria-selected', 'false');
          li.innerHTML =
            '<span class="klc-prod__img">' + (r.i ? '<img src="' + escapeHtml(_imgUrl(r.i, 96)) + '" alt="" width="36" height="36" loading="lazy">' : _svg(ICO_BOX, 16)) + '</span>' +
            '<span class="klc-pick__t">' + _mark(r.t, q) + '</span>' +
            (r.p ? '<span class="klc-pick__p">' + escapeHtml(_fmtPrice(r.p)) + '</span>' : '');
          li.addEventListener('mousedown', function (e) { e.preventDefault(); });
          li.addEventListener('click', function () { selectPicked(r); });
          li.addEventListener('mousemove', function () { if (active !== k) setActive(k); });
          list.appendChild(li);
        });
        list.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        active = -1;
      }
      function recent() {
        var rows = _readRecent().filter(function (r) { return r && r.t; }).map(function (r) { return { t: r.t, u: r.u, i: r.i, p: '' }; });
        if (rows.length) draw(rows, '', KLC_I18N.pickRecent || ''); else close();
      }
      function search(q) {
        var my = ++seq;
        if (ctrl && ctrl.abort) { try { ctrl.abort(); } catch (e) {} }
        ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
        spin.hidden = false;
        var url = (window.__KLC_CFG.root || '/') + 'search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources%5Btype%5D=product&resources%5Blimit%5D=6&resources%5Boptions%5D%5Bunavailable_products%5D=last';
        fetch(url, { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (d) {
            if (my !== seq) return;
            spin.hidden = true;
            var ps = (d && d.resources && d.resources.results && d.resources.results.products) || [];
            draw(ps.map(function (p) {
              var img = p.image || (p.featured_image && p.featured_image.url) || '';
              return { t: p.title, u: p.url, i: img, p: p.price };
            }), q, '');
          })
          .catch(function () { if (my === seq) spin.hidden = true; });
      }
      input.addEventListener('input', function () {
        var q = input.value.trim();
        if (timer) clearTimeout(timer);
        if (q.length < 2) { seq++; spin.hidden = true; recent(); return; }
        timer = setTimeout(function () { search(q); }, 220);
      });
      input.addEventListener('focus', function () { if (input.value.trim().length < 2) recent(); });
      input.addEventListener('blur', function () { setTimeout(close, 120); });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); if (list.hidden) { input.value.trim().length < 2 ? recent() : search(input.value.trim()); } else setActive(active + 1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
        else if (e.key === 'Enter') { e.preventDefault(); if (!list.hidden && active >= 0 && items[active]) selectPicked(items[active]); }
        else if (e.key === 'Escape') { if (!list.hidden) { e.stopPropagation(); e.preventDefault(); close(); } }
      });
      host.appendChild(wrap);
      if (autoFocus) setTimeout(function () { input.focus(); }, 30);
      return input;
    }
    function _renderPicker(host) {
      var inCard = host.hasAttribute('data-klc-pick-host');
      var show = !_pdpProductActive();
      host.hidden = !show;
      host.innerHTML = '';
      if (!show) return;
      if (inCard) {
        var lab = document.createElement('p');
        lab.className = 'klc-pick__label';
        lab.innerHTML = escapeHtml(KLC_I18N.pickLabel || '') + ' <span>' + escapeHtml(KLC_I18N.pickOpt || '') + '</span>';
        host.appendChild(lab);
      }
      if (_picked) { host.appendChild(_selectedCard(function () { selectPicked(null); var i = host.querySelector('.klc-pick__input, .klc-pick__open'); if (i) i.focus(); })); return; }
      if (inCard || host._open) { _searchBox(host, !!host._open && !inCard); return; }
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'klc-pick__open';
      b.innerHTML = '<span class="klc-pick__ico">' + _svg(ICO_SEARCH, 17) + '</span><span class="klc-pick__open-t">' + escapeHtml(KLC_I18N.pickLabel || '') + '</span>';
      b.addEventListener('click', function () { host._open = true; _renderPicker(host); });
      host.appendChild(b);
    }
    function renderPickers() {
      _pickHosts = _pickHosts.filter(function (h) { return h.isConnected || h === pickHost; });
      _pickHosts.forEach(_renderPicker);
    }
    if (pickHost) { _pickHosts.push(pickHost); _renderPicker(pickHost); }
    var KLC_ID_KEY = 'klc_identity';
    (function () {
      var o = _readIdentity();
      if (o && o.email) { klcContext.email = o.email; klcContext.name = o.name || ''; } // nur Vorbelegung der Karte
    })();

    function pushContextToCrisp(ctx) {
      if (ctx.email) crispPush(['set', 'user:email', [ctx.email]]);
      if (ctx.name)  crispPush(['set', 'user:nickname', [ctx.name]]);
      var data = [];
      if (ctx.topicLabel)  data.push(['topic', ctx.topicLabel]);
      if (ctx.hasOrder)    data.push(['has_order', ctx.hasOrder]);
      if (ctx.orderNumber) data.push(['order_number', ctx.orderNumber]);
      if (ctx.software)    data.push(['software', ctx.software]);
      // Direkt öffnbar in Crisp — nur auf der Seite des Produkts, das der Besucher nicht weggeklickt hat.
      if (ctx.software && prodBar && !prodDismissed) data.push(['product_url', window.location.origin + window.location.pathname]);
      else if (ctx.software && ctx.productUrl) data.push(['product_url', ctx.productUrl]);
      if (!ctx.software && ctx.lastViewed) data.push(['last_viewed_product', ctx.lastViewed]);
      if (ctx.platform)    data.push(['platform', ctx.platform]);
      data.push(['page_url', window.location.href]);
      data.push(['device', getDeviceType()]);
      data.push(['timestamp', new Date().toISOString()]);
      crispPush(['set', 'session:data', [data]]);
      pushVisitorFacts();
      // Compact context block for the operator — shown locally as a small,
      // muted bubble so the visitor sees exactly what was sent.
      var lines = [];
      lines.push(KLC_I18N.ctxHeader);
      if (ctx.topicLabel)  lines.push(KLC_I18N.ctxTopic    + ': ' + ctx.topicLabel);
      if (ctx.orderNumber) lines.push(KLC_I18N.ctxOrder    + ': ' + ctx.orderNumber);
      else if (ctx.hasOrder === 'no' && KLC_I18N.ctxNoOrder) lines.push(KLC_I18N.ctxOrder + ': ' + KLC_I18N.ctxNoOrder);
      if (ctx.software)    lines.push(KLC_I18N.ctxSoftware + ': ' + ctx.software);
      if (ctx.platform)    lines.push(KLC_I18N.ctxPlatform + ': ' + ctx.platform);
      lines.push(KLC_I18N.ctxPage   + ': ' + window.location.href);
      lines.push(KLC_I18N.ctxDevice + ': ' + getDeviceType());
      var text = lines.join('\n');
      _noteOwnText(text);
      appendMessage('user', text, Date.now(), 'klc-msg--ctx');
      crispPush(['do', 'message:send', ['text', text]]);
    }

    /* ── Sending text ─────────────────────────────────────── */
    function sendText(text) {
      text = String(text || '').trim();
      if (!text) return;
      _noteOwnText(text);
      appendMessage('user', text, Date.now());
      crispPush(['do', 'message:send', ['text', text]]);
    }
    function sendMessage() {
      if (!chatInput) return;
      var text = chatInput.value.trim();
      if (!text) return;
      // Pflichtangaben zuerst (23.09.2026). Der Text bleibt im Feld stehen, bis er wirklich rausgeht.
      requireIdentity(function () {
        if (chatInput.value.trim() === text) { chatInput.value = ''; autoSize(); chatSend.disabled = true; }
        sendText(text);
      }, 'text');
    }
    function autoSize() {
      if (!chatInput) return;
      chatInput.style.height = 'auto';
      chatInput.style.height = Math.min(chatInput.scrollHeight, 96) + 'px';
    }

    /* ── Quick actions: the visitor's own words, sent as a message ── */
    Array.prototype.forEach.call(document.querySelectorAll('[data-klc-qa]'), function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-klc-qa');
        var label = (btn.querySelector('.klc-qa__txt') || btn).textContent.trim();
        klcContext.topic = key;
        klcContext.topicLabel = TOPIC_LABEL[key] || label;
        requireIdentity(function () {
          crispPush(['set', 'session:segments', [['quick-action', key], false]]);
          sendText(label);
          afterQuickAction(key);
          chatInput && chatInput.focus();
        }, 'text');
      });
    });

    /* ── Tipp + Anleitungskarte (26.09.2026) ─────────────────────────
       Lokale UI-Hilfen nach einem Schnellanliegen — KEIN Bot: nichts davon wird als
       Antwort des Shops ausgegeben oder als Nachricht an Crisp geschickt.
         key-invalid → Tipp „Screenshot / Fehlercode“ mit Anhängen-Knopf;
         install     → Karte mit der passenden Blog-Anleitung (Familie aus
                       __KLC_CFG.guides, Produktname aus Kontext/Wähler/PDP),
                       danach der Screenshot-Tipp.
       Nur einmal je Schlüssel und Gespräch; nicht im Transkript/Verlauf; ✎ Neu
       räumt sie mit dem Stream weg. Der Operator sieht über session:data
       guide_shown, welche Anleitung der Kunde bekam. */
    var _tipShown = {};
    function afterQuickAction(key) {
      var i18n = KLC_I18N;
      if (key === 'install') {
        var g = findGuide();
        if (g) showGuideCard(g);
        showTip('install', i18n.tipInstall);
      } else if (key === 'key-invalid') {
        showTip('err', i18n.tipErr);
      }
    }
    function productNameForGuide() {
      var n = klcContext.software || (_picked && _picked.t) || '';
      if (!n && !prodDismissed) n = (klcRoot.getAttribute('data-klc-product') || '');
      return String(n || '');
    }
    function findGuide() {
      var name = productNameForGuide();
      var list = window.__KLC_CFG.guides || [];
      if (!name) return null;
      for (var i = 0; i < list.length; i++) {
        var g = list[i];
        try {
          if (!new RegExp(g.re, 'i').test(name)) continue;
          if (g.not && new RegExp(g.not, 'i').test(name)) continue;
        } catch (e) { continue; }
        return g;
      }
      return null;
    }
    function showTip(kind, text) {
      if (!chatStream || !text || _tipShown[kind]) return;
      _tipShown[kind] = true;
      var i18n = KLC_I18N;
      var p = document.createElement('div');
      p.className = 'klc-tip';
      p.setAttribute('role', 'note');
      var ico = document.createElement('span');
      ico.className = 'klc-tip__ico';
      ico.setAttribute('aria-hidden', 'true');
      ico.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18h6"/><path d="M10 22h4"/><path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .23 2.23 1.5 3.5A4.61 4.61 0 0 1 8.91 14"/></svg>';
      var txt = document.createElement('span');
      txt.className = 'klc-tip__txt';
      txt.textContent = text;
      p.appendChild(ico);
      p.appendChild(txt);
      if (chatAttach && chatFile && KLC_UPLOAD_URL && i18n.tipAttach) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'klc-tip__btn';
        b.textContent = i18n.tipAttach;
        b.addEventListener('click', function () { chatFile.click(); });
        p.appendChild(b);
      }
      _mount(p);
    }
    function showGuideCard(g) {
      if (!chatStream || !g || _tipShown['guide']) return;
      _tipShown['guide'] = true;
      var i18n = KLC_I18N;
      var card = document.createElement('div');
      card.className = 'klc-guide';
      card.innerHTML =
        '<span class="klc-guide__ico" aria-hidden="true"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg></span>' +
        '<span class="klc-guide__body"><span class="klc-guide__label"></span><span class="klc-guide__name"></span><span class="klc-guide__links"></span></span>';
      card.querySelector('.klc-guide__label').textContent = i18n.guideLabel || '';
      card.querySelector('.klc-guide__name').textContent = g.name || '';
      var links = card.querySelector('.klc-guide__links');
      function addLink(href, label) {
        if (!href || !label) return;
        var a = document.createElement('a');
        a.className = 'klc-guide__link';
        a.href = href;
        a.target = '_blank';
        a.rel = 'noopener';
        a.textContent = label;
        links.appendChild(a);
      }
      addLink(g.url, i18n.guideOpen);
      addLink(g.dl, i18n.guideDl);
      _mount(card);
      crispPush(['set', 'session:data', [['guide_shown', g.id || g.name]]]);
    }

    /* ── Identity card — PFLICHT vor der ersten Nachricht eines Gesprächs ──
       Händlerwunsch 23.09.2026: erst „Haben Sie bereits eine Bestellung?“ (Ja/Nein),
       dann Name + E-Mail (Pflicht), bei „Ja“ zusätzlich die Bestellnummer (Pflicht).
       Kein „Später“. requireIdentity() hält jede Sende-Aktion (Text, Schnellanliegen,
       Datei, Sprachnachricht) zurück, bis die Karte ausgefüllt ist; Text hat EINEN
       Warteplatz, damit ein zweiter Klick nicht doppelt sendet.
       „Erledigt“ gilt je Gespräch: localStorage['klc_id_session'] = Crisp-Session-ID,
       für die ausgefüllt wurde; Rückfall ohne ID sessionStorage['klc_id_done']. Ein neues
       Gespräch (✎ → session:reset) fragt erneut — Name/E-Mail sind dann vorbelegt. */
    var ID_SESSION_KEY = 'klc_id_session';
    var ID_DONE_KEY = 'klc_id_done';
    var ORDER_TOPICS = { 'key-missing': 1, 'key-invalid': 1, 'order': 1, 'invoice': 1, 'payment': 1 };
    var _pendingSends = [];
    var _idCard = null;
    function crispSessionId() {
      try { return (window.$crisp && typeof window.$crisp.get === 'function' && window.$crisp.get('session:identifier')) || ''; }
      catch (e) { return ''; }
    }
    function identityDone() {
      try { if (sessionStorage.getItem(ID_DONE_KEY) === '1') return true; } catch (e) {}
      var sid = crispSessionId();
      if (!sid) return false;
      try { return localStorage.getItem(ID_SESSION_KEY) === sid; } catch (e) { return false; }
    }
    function rememberIdentityDone() {
      try { sessionStorage.setItem(ID_DONE_KEY, '1'); } catch (e) {}
      var tries = 0;
      (function tick() {
        var sid = crispSessionId();
        if (sid) { try { localStorage.setItem(ID_SESSION_KEY, sid); } catch (e) {} return; }
        if (++tries < 20) setTimeout(tick, 500); // Crisp lädt evtl. gerade erst
      })();
    }
    var NEW_CONVO_KEY = 'klc_new_convo';
    function _newConvoAsked() { try { return sessionStorage.getItem(NEW_CONVO_KEY) === '1'; } catch (e) { return false; } }
    function _setNewConvo(on) { try { if (on) sessionStorage.setItem(NEW_CONVO_KEY, '1'); else sessionStorage.removeItem(NEW_CONVO_KEY); } catch (e) {} }
    function forgetIdentityDone() {
      try { sessionStorage.removeItem(ID_DONE_KEY); localStorage.removeItem(ID_SESSION_KEY); } catch (e) {}
    }
    var _idWaiting = false;
    function _runPending() {
      var run = _pendingSends; _pendingSends = [];
      run.forEach(function (p) { p.fn(); });
    }
    function requireIdentity(fn, key) {
      if (identityDone()) { fn(); return; }
      if (key) _pendingSends = _pendingSends.filter(function (p) { return p.key !== key; });
      _pendingSends.push({ key: key || '', fn: fn });
      if (_idWaiting) return;
      /* Gleiches Gespräch, Crisp nur noch nicht geladen: erst die Sitzung abwarten
         (max. 3 s), sonst käme die Karte einem Rückkehrer zu Unrecht (24.09.2026). */
      var stored = '';
      try { stored = localStorage.getItem(ID_SESSION_KEY) || ''; } catch (e) {}
      if (stored && !crispSessionId()) {
        _idWaiting = true;
        loadCrisp(function () {
          var t0 = Date.now();
          (function wait() {
            if (!crispSessionId() && Date.now() - t0 < 3000) { setTimeout(wait, 150); return; }
            _idWaiting = false;
            if (identityDone()) _runPending();
            else showIdCard();
          })();
        });
        return;
      }
      showIdCard();
    }
    function showIdCard() {
      if (_idCard && _idCard.parentNode) {
        if (chatStream) chatStream.scrollTop = chatStream.scrollHeight;
        var first = _idCard.querySelector('.klc-idcard__choice[aria-checked="true"]') ? _idCard.querySelector('input[name="name"]') : _idCard.querySelector('.klc-idcard__choice');
        if (first) first.focus();
        return;
      }
      if (!idCardTpl || !chatStream) return;
      var node = (idCardTpl.content && idCardTpl.content.firstElementChild)
        ? idCardTpl.content.firstElementChild.cloneNode(true) : null;
      if (!node) return;
      var form   = node.querySelector('form');
      var email  = node.querySelector('input[name="email"]');
      var name   = node.querySelector('input[name="name"]');
      var order  = node.querySelector('input[name="order"]');
      var choices = node.querySelectorAll('.klc-idcard__choice');
      var hasOrder = '';
      function err(k, on) { var e = node.querySelector('[data-klc-err="' + k + '"]'); if (e) e.hidden = !on; }
      function choose(v) {
        hasOrder = v;
        Array.prototype.forEach.call(choices, function (c) {
          c.setAttribute('aria-checked', c.getAttribute('data-klc-has-order') === v ? 'true' : 'false');
        });
        if (order) { order.hidden = v !== 'yes'; if (v !== 'yes') { order.classList.remove('is-error'); err('order', false); } }
        err('choice', false);
      }
      Array.prototype.forEach.call(choices, function (c) {
        c.addEventListener('click', function () {
          choose(c.getAttribute('data-klc-has-order'));
          var next = (name && !name.value.trim()) ? name : (email && !email.value.trim()) ? email : (hasOrder === 'yes' ? order : null);
          if (next) next.focus();
        });
      });
      [['name', name], ['email', email], ['order', order]].forEach(function (pair) {
        if (pair[1]) pair[1].addEventListener('input', function () { pair[1].classList.remove('is-error'); err(pair[0], false); });
      });
      var pickSlot = node.querySelector('[data-klc-pick-host]');
      if (pickSlot) { _pickHosts.push(pickSlot); _renderPicker(pickSlot); }
      if (name) name.value = klcContext.name || '';
      if (email) email.value = klcContext.email || '';
      if (order && klcContext.orderNumber) order.value = klcContext.orderNumber;
      // Schnellanliegen rund um eine Bestellung: „Ja“ ist wahrscheinlich — vorwählen.
      if (ORDER_TOPICS[klcContext.topic]) choose('yes');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var vName  = (name && name.value || '').replace(/\s+/g, ' ').trim();
        var vEmail = (email && email.value || '').trim();
        var vOrder = (order && order.value || '').replace(/\s+/g, '');
        var okChoice = hasOrder === 'yes' || hasOrder === 'no';
        var okName   = vName.length >= 2;
        var okEmail  = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(vEmail);
        // Nachsichtig: Shop „#1234“, Kaufland „MA9ZTL5“, Bindestriche erlaubt.
        var okOrder  = hasOrder !== 'yes' || /^#?[A-Za-z0-9][A-Za-z0-9-]{2,39}$/.test(vOrder);
        err('choice', !okChoice);
        if (name)  { name.classList.toggle('is-error', !okName); err('name', !okName); }
        if (email) { email.classList.toggle('is-error', !okEmail); err('email', !okEmail); }
        if (order) { order.classList.toggle('is-error', !okOrder); err('order', !okOrder); }
        if (!okChoice) { if (choices[0]) choices[0].focus(); return; }
        if (!okName)   { name.focus(); return; }
        if (!okEmail)  { email.focus(); return; }
        if (!okOrder)  { order.focus(); return; }
        klcContext.name = vName;
        klcContext.email = vEmail;
        klcContext.hasOrder = hasOrder;
        klcContext.orderNumber = hasOrder === 'yes' ? vOrder : '';
        try { localStorage.setItem(KLC_ID_KEY, JSON.stringify({ email: vEmail, name: vName, ts: Date.now() })); } catch (e2) {}
        finish();
      });
      function finish() {
        rememberIdentityDone();
        _setNewConvo(false);
        if (node.parentNode) node.parentNode.removeChild(node);
        _idCard = null;
        loadCrisp(function () {
          pushContextToCrisp(klcContext);
          _runPending();
        });
        chatInput && chatInput.focus();
      }
      /* Wiedererkannt (24.09.2026): Name + E-Mail sind auf diesem Gerät bekannt und
         der Besucher hat nicht selbst ✎ gewählt (das alte Gespräch ist z. B. nach
         7 Tagen Safari weg) → ein Klick statt der ganzen Karte. „Andere Angaben"
         öffnet die normale Karte, vorbelegt. */
      var known = _knownIdentity();
      var backBox = node.querySelector('[data-klc-back]');
      var compact = !!(backBox && known && known.email && known.name && !_newConvoAsked());
      function showFull(on) {
        Array.prototype.forEach.call(node.querySelectorAll('[data-klc-full]'), function (el) { el.hidden = !on; });
        if (backBox) backBox.hidden = on;
      }
      if (compact) {
        showFull(false);
        var bt = backBox.querySelector('[data-klc-back-title]');
        if (bt) bt.textContent = bt.textContent.replace('{name}', known.name.split(' ')[0]);
        var be = backBox.querySelector('[data-klc-back-email]');
        if (be) be.textContent = known.email;
        backBox.querySelector('[data-klc-back-yes]').addEventListener('click', function () {
          klcContext.name = known.name;
          klcContext.email = known.email;
          klcContext.hasOrder = '';
          klcContext.orderNumber = '';
          finish();
        });
        backBox.querySelector('[data-klc-back-other]').addEventListener('click', function () {
          showFull(true);
          var f = hasOrder ? name : choices[0];
          if (f) f.focus();
        });
      }
      _startThread();
      chatStream.appendChild(node);
      _idCard = node;
      chatStream.scrollTop = chatStream.scrollHeight;
      setTimeout(function () {
        if (compact) { var y = backBox.querySelector('[data-klc-back-yes]'); if (y) y.focus(); return; }
        var f = hasOrder ? (name && !name.value ? name : email && !email.value ? email : order && !order.hidden && !order.value ? order : node.querySelector('.klc-idcard__submit')) : choices[0];
        if (f) f.focus();
      }, 80);
    }

    /* ── Uploads (images, video, audio) ───────────────────
       Target is EXCLUSIVELY our own endpoint (__KLC_CFG.uploadUrl → the
       KARINEX app on Railway → Cloudflare R2, EU, deleted after 180 days).

       There is NO third-party fallback any more. Until 09/2026 this posted to
       tmpfiles.org: no data processing agreement, file public by URL for 60
       minutes, and the shop's privacy policy never named it — a customer
       photographing an invoice handed their name and address to an unknown
       recipient. Do not reintroduce one.

       The former override hook window.KARINEX_CHAT_UPLOADER is gone on
       purpose too: any third-party script on the page (GTM, Ahrefs, TikTok)
       could have set it and silently redirected every visitor photo.

       NO headers object on the fetch: FormData then stays a CORS simple
       request (multipart/form-data is safelisted), so there is no preflight —
       same pattern as kx-exit-intent.liquid. Setting Content-Type by hand
       would destroy the multipart boundary AND trigger a preflight.

       MAX_UPLOAD_BYTES must match MAX_BYTES in
       app/api/public/chat-upload/route.ts (repo invoice). */
    var MAX_UPLOAD_BYTES = 10 * 1024 * 1024;
    function uploadFile(file) {
      return new Promise(function (resolve, reject) {
        // fetch('') would POST against the current shop page and answer 200
        // with HTML — it fails only at r.json(). Guard it explicitly.
        if (!KLC_UPLOAD_URL) { reject(new Error('upload-disabled')); return; }
        var fd = new FormData();
        fd.append('file', file, file.name || 'upload');
        fetch(KLC_UPLOAD_URL, { method: 'POST', body: fd })
          .then(function (r) { return r.json().catch(function () { return null; }); })
          .then(function (j) {
            if (!j || !j.ok || !j.url) { reject(new Error('upload-' + ((j && j.error) || 'failed'))); return; }
            resolve({ url: j.url, name: j.name || file.name || 'upload', type: j.type || file.type });
          })
          .catch(reject);
      });
    }
    function tooLarge(file) {
      if (!file || file.size <= MAX_UPLOAD_BYTES) return false;
      var mb = Math.round(MAX_UPLOAD_BYTES / 1048576);
      appendSystemNote(String(KLC_I18N.errTooLarge || '').replace('{mb}', String(mb)));
      return true;
    }
    function handleFilePick(file) {
      if (!file || !chatStream) return;
      var isImage = /^image\//.test(file.type);
      var isVideo = /^video\//.test(file.type);
      if (!isImage && !isVideo) {
        appendSystemNote(KLC_I18N.errImageVideo);
        return;
      }
      // Before the optimistic bubble: a 40 MB video would otherwise upload for
      // a minute and end in a bare "upload failed". The server 413 stays as the net.
      if (tooLarge(file)) return;
      // Pflichtangaben zuerst (23.09.2026): die Datei wartet, bis die Karte ausgefüllt ist.
      if (!identityDone()) { requireIdentity(function () { handleFilePick(file); }); return; }
      // optimistic preview
      var localUrl = URL.createObjectURL(file);
      var bubble = isVideo
        ? appendVideo('user', localUrl, Date.now())
        : appendImage('user', localUrl, Date.now());
      if (bubble) bubble.classList.add('klc-msg--uploading');
      loadCrisp(function () {
        uploadFile(file).then(function (info) {
          if (bubble) bubble.classList.remove('klc-msg--uploading');
          _noteOwnFile(info.url, bubble);
          crispPush(['do', 'message:send', ['file', { name: info.name, url: info.url, type: info.type }]]);
        }).catch(function (err) {
          console.warn('Karinex chat: upload failed', err);
          markFailed(bubble);
        });
      });
    }

    /* ── Voice messages (MediaRecorder → upload → Crisp "audio") ── */
    var REC_MAX_MS = 120000;
    var rec = null; // { mr, stream, chunks, startedAt, tick, stopTimer, intent, mime }
    function micSupported() {
      return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia && window.MediaRecorder);
    }
    function pickMime() {
      var cands = ['audio/webm;codecs=opus', 'audio/webm', 'audio/mp4', 'audio/ogg;codecs=opus'];
      for (var i = 0; i < cands.length; i++) {
        try { if (window.MediaRecorder.isTypeSupported(cands[i])) return cands[i]; } catch (e) {}
      }
      return '';
    }
    function setRecording(on) {
      if (inputWrap) inputWrap.classList.toggle('is-recording', on);
      if (recBar) recBar.hidden = !on;
    }
    function startRecording() {
      if (rec || !micSupported()) return;
      navigator.mediaDevices.getUserMedia({ audio: true }).then(function (stream) {
        var mime = pickMime();
        var mr;
        try { mr = mime ? new MediaRecorder(stream, { mimeType: mime }) : new MediaRecorder(stream); }
        catch (e) { stream.getTracks().forEach(function (t) { t.stop(); }); appendSystemNote(KLC_I18N.recDenied); return; }
        rec = { mr: mr, stream: stream, chunks: [], startedAt: Date.now(), intent: 'cancel', mime: mr.mimeType || mime || 'audio/webm' };
        mr.addEventListener('dataavailable', function (e) { if (e.data && e.data.size) rec.chunks.push(e.data); });
        mr.addEventListener('stop', finishRecording);
        mr.start(250);
        setRecording(true);
        if (recTime) recTime.textContent = '0:00';
        rec.tick = setInterval(function () {
          if (recTime && rec) recTime.textContent = fmtDuration((Date.now() - rec.startedAt) / 1000);
        }, 250);
        rec.stopTimer = setTimeout(function () { stopRecording('send'); }, REC_MAX_MS);
      }).catch(function () {
        appendSystemNote(KLC_I18N.recDenied);
      });
    }
    function stopRecording(intent) {
      if (!rec) return;
      rec.intent = intent || 'cancel';
      try { if (rec.mr.state !== 'inactive') rec.mr.stop(); else finishRecording(); } catch (e) { finishRecording(); }
    }
    function finishRecording() {
      if (!rec) return;
      var r = rec; rec = null;
      clearInterval(r.tick); clearTimeout(r.stopTimer);
      try { r.stream.getTracks().forEach(function (t) { t.stop(); }); } catch (e) {}
      setRecording(false);
      var duration = Math.max(1, Math.round((Date.now() - r.startedAt) / 1000));
      if (r.intent !== 'send' || !r.chunks.length) return;
      var type = (r.mime || 'audio/webm').split(';')[0];
      var ext  = type.indexOf('mp4') !== -1 ? 'm4a' : type.indexOf('ogg') !== -1 ? 'ogg' : 'webm';
      var blob = new Blob(r.chunks, { type: type });
      var file;
      try { file = new File([blob], 'voice-' + Date.now() + '.' + ext, { type: type }); }
      catch (e) { file = blob; try { file.name = 'voice-' + Date.now() + '.' + ext; } catch (e2) {} }
      // 120 s Opus liegen bei ~500 KB, das greift also nie — aber ein
      // kuenftiger Codec soll nicht stumm ins 413 laufen.
      if (tooLarge(file)) return;
      // Aufnehmen geht ohne Angaben, SENDEN erst nach der Pflichtkarte (23.09.2026).
      if (!identityDone()) { requireIdentity(function () { sendVoice(file, blob, type, duration); }); return; }
      sendVoice(file, blob, type, duration);
    }
    function sendVoice(file, blob, type, duration) {
      var localUrl = URL.createObjectURL(blob);
      var bubble = appendAudio('user', localUrl, Date.now(), duration);
      if (bubble) bubble.classList.add('klc-msg--uploading');
      loadCrisp(function () {
        uploadFile(file).then(function (info) {
          if (bubble) bubble.classList.remove('klc-msg--uploading');
          _noteOwnFile(info.url, bubble);
          if (bubble && bubble._klcEntry) bubble._klcEntry.duration = duration;
          crispPush(['do', 'message:send', ['audio', { type: type, url: info.url, duration: duration }]]);
        }).catch(function (err) {
          console.warn('Karinex chat: voice upload failed', err);
          markFailed(bubble);
        });
      });
    }
    // Ohne Upload-Endpunkt kann eine Sprachnachricht nirgends hin.
    if (chatMic && KLC_UPLOAD_URL && micSupported()) {
      chatMic.hidden = false;
      chatMic.addEventListener('click', startRecording);
    }
    if (recCancel) recCancel.addEventListener('click', function () { stopRecording('cancel'); });
    if (recSend)   recSend.addEventListener('click',   function () { stopRecording('send'); });

    /* ── History ───────────────────────────────────────────
       Crisp knows only the current session. Earlier conversations exist
       solely as snapshots we take when the visitor starts a new one:
       localStorage['klc_history'] — this device only, never sent anywhere,
       max 10 entries / 90 days, plain text + file URLs. */
    var KLC_HIST_KEY   = 'klc_history';
    var KLC_HIST_MAX   = 10;
    var KLC_HIST_MAXAGE = 90 * 86400000;
    function histLoad() {
      try {
        var raw = localStorage.getItem(KLC_HIST_KEY);
        var arr = raw ? JSON.parse(raw) : [];
        if (!Array.isArray(arr)) return [];
        var cutoff = Date.now() - KLC_HIST_MAXAGE;
        return arr.filter(function (e) { return e && e.endedAt > cutoff && Array.isArray(e.messages) && e.messages.length; });
      } catch (_) { return []; }
    }
    function histSave(arr) {
      try {
        if (!arr.length) localStorage.removeItem(KLC_HIST_KEY);
        else localStorage.setItem(KLC_HIST_KEY, JSON.stringify(arr.slice(-KLC_HIST_MAX)));
      } catch (_) {}
    }
    function histArchiveCurrent() {
      if (!_transcript.length) return;
      var arr = histLoad();
      arr.push({
        id: String(Date.now()),
        startedAt: _transcript[0].ts || Date.now(),
        endedAt: Date.now(),
        topic: klcContext.topicLabel || '',
        messages: _transcript.map(function (m) {
          if (m.type === 'text')  return { from: m.from, type: 'text', text: m.text, ts: m.ts };
          if (m.type === 'audio') return { from: m.from, type: 'audio', url: m.url, duration: m.duration || 0, ts: m.ts };
          return { from: m.from, type: m.type, url: m.url, ts: m.ts };
        })
      });
      histSave(arr);
    }
    function histClearAll() { histSave([]); renderHistoryList(); }
    function previewOf(messages) {
      for (var i = messages.length - 1; i >= 0; i--) {
        var m = messages[i];
        if (m.type === 'text' && m.text) {
          var line = m.text.split('\n').filter(function (l) { return l.trim(); }).pop() || '';
          return line.length > 70 ? line.slice(0, 68) + '…' : line;
        }
        if (m.type === 'audio') return KLC_I18N.audioLabel || '';
        if (m.type === 'image' || m.type === 'video') return KLC_I18N.attach || '';
      }
      return '';
    }
    function histRow(title, meta, onClick) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'klc-row klc-hist-row';
      b.innerHTML =
        '<span class="klc-row__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg></span>' +
        '<span class="klc-row__txt"><span class="klc-row__title"></span><span class="klc-row__meta"></span></span>' +
        '<svg class="klc-row__chev" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>';
      b.querySelector('.klc-row__title').textContent = title;
      b.querySelector('.klc-row__meta').textContent  = meta;
      b.addEventListener('click', onClick);
      return b;
    }
    function renderHistoryList() {
      if (!histItems) return;
      histItems.innerHTML = '';
      var any = false;
      if (_transcript.length) {
        any = true;
        histItems.appendChild(histRow(KLC_I18N.histCurrent || '', previewOf(_transcript), function () { closeSubViews(); }));
      }
      var arr = histLoad();
      for (var i = arr.length - 1; i >= 0; i--) {
        any = true;
        (function (entry) {
          var meta = (entry.topic ? entry.topic + ' · ' : '') + previewOf(entry.messages);
          histItems.appendChild(histRow(fmtDate(entry.endedAt), meta, function () { openTranscript(entry); }));
        })(arr[i]);
      }
      if (histEmpty) histEmpty.hidden = any;
      if (histClear) histClear.hidden = !arr.length;
    }
    function renderReadonlyBubble(m) {
      var div = document.createElement('div');
      div.className = 'klc-msg klc-msg--' + (m.from === 'user' ? 'user' : 'agent');
      if (m.type === 'image') {
        div.className += ' klc-msg--image';
        var img = document.createElement('img'); img.src = m.url; img.alt = ''; img.loading = 'lazy';
        img.addEventListener('click', function () { openLightbox(m.url); });
        div.appendChild(img);
      } else if (m.type === 'video') {
        div.className += ' klc-msg--video';
        var v = document.createElement('video'); v.src = m.url; v.controls = true; v.preload = 'metadata';
        div.appendChild(v);
      } else if (m.type === 'audio') {
        div.className += ' klc-msg--audio';
        var lab = document.createElement('span'); lab.className = 'klc-msg__label';
        lab.textContent = (KLC_I18N.audioLabel || '') + (m.duration ? ' · ' + fmtDuration(m.duration) : '');
        div.appendChild(lab);
        var a = document.createElement('audio'); a.src = m.url; a.controls = true; a.preload = 'metadata';
        div.appendChild(a);
      } else {
        if (KLC_I18N.ctxHeader && m.from === 'user' && String(m.text || '').indexOf(KLC_I18N.ctxHeader) === 0) div.className += ' klc-msg--ctx';
        div.appendChild(document.createTextNode(m.text || ''));
      }
      div.appendChild(_timeEl(m.ts));
      return div;
    }
    function openTranscript(entry) {
      if (!histTrans || !histStream) return;
      histStream.innerHTML = '';
      entry.messages.forEach(function (m) { histStream.appendChild(renderReadonlyBubble(m)); });
      document.getElementById('klcHistList').hidden = true;
      histTrans.hidden = false;
      histStream.scrollTop = 0;
    }
    function updateHistoryBadge() {
      if (histBadge) histBadge.hidden = !hasMessages;
    }

    /* ── Views: chat (default) · menu · history ───────────── */
    function closeSubViews() {
      panel.classList.remove('is-menu');
      panel.classList.remove('is-history');
    }
    function openMenu() {
      panel.classList.remove('is-history');
      panel.classList.add('is-menu');
    }
    function openHistory() {
      panel.classList.remove('is-menu');
      panel.classList.add('is-history');
      if (histTrans) histTrans.hidden = true;
      document.getElementById('klcHistList').hidden = false;
      renderHistoryList();
    }
    function historyBack() {
      if (histTrans && !histTrans.hidden) {
        histTrans.hidden = true;
        document.getElementById('klcHistList').hidden = false;
        return;
      }
      closeSubViews();
    }
    function subViewBack() {
      if (panel.classList.contains('is-history')) historyBack();
      else closeSubViews();
    }

    /* ── New conversation ─────────────────────────────────────
       session:reset without [true] = no page reload (Crisp docs, checked
       22.09.2026). _seenFingerprints is deliberately KEPT: should the poll
       still return the old session for a tick, those messages stay
       recognised and are not drawn into the fresh thread. */
    function startNewConversation() {
      if (rec) stopRecording('cancel');
      histArchiveCurrent();
      _transcript = [];
      resetWait();
      _pendingOwn = [];
      _ownFileUrls = {};
      // Neues Gespräch = neue Pflichtkarte (Name/E-Mail bleiben als Vorbelegung).
      forgetIdentityDone();
      _setNewConvo(true);
      if (_idCard && _idCard.parentNode) _idCard.parentNode.removeChild(_idCard);
      _idCard = null; _pendingSends = [];
      klcContext.topic = ''; klcContext.topicLabel = ''; klcContext.orderNumber = ''; klcContext.hasOrder = '';
      _tipShown = {};
      removeTyping();
      if (chatStream) {
        chatStream.innerHTML = '';
        chatStream.classList.remove('is-started');
        if (chatEmpty) { chatEmpty.classList.remove('is-started'); chatStream.appendChild(chatEmpty); }
      }
      hasMessages = false;
      scrollStreamHome();
      updateHistoryBadge();
      try { if (window.$crisp && window.$crisp.push) window.$crisp.push(['do', 'session:reset']); } catch (_) {}
      closeSubViews();
      chatInput && chatInput.focus();
    }
    function requestNewConversation() {
      if (!hasMessages || !confirmBox) { startNewConversation(); return; }
      confirmBox.hidden = false;
      setTimeout(function () { confirmNo && confirmNo.focus(); }, 30);
    }
    function closeConfirm() { if (confirmBox) confirmBox.hidden = true; }

    /* ── Full-screen mode (⤢) ─────────────────────────────── */
    var KLC_FULL_KEY = 'klc_full';
    function setFull(on) {
      panel.classList.toggle('is-full', on);
      document.documentElement.classList.toggle('klc-full-open', on && panel.classList.contains('is-open'));
      if (headerFull) {
        var lab = headerFull.getAttribute(on ? 'data-label-unfull' : 'data-label-full') || '';
        headerFull.setAttribute('aria-label', lab);
        headerFull.title = lab;
      }
      try { if (on) sessionStorage.setItem(KLC_FULL_KEY, '1'); else sessionStorage.removeItem(KLC_FULL_KEY); } catch (e) {}
    }
    function isFull() { return panel.classList.contains('is-full'); }

    /* Where the thread opens: an ongoing chat (or the identity card) at the bottom,
       the welcome screen at the top. The welcome screen is bottom-anchored while it
       fits; on product pages it carries the product row as well and overflows, and
       then the top reads like the Lizenzguru reference (merchant, 23.09.2026):
       wordmark, product, "Hallo", "Lizenzschlüssel nicht erhalten" … */
    function scrollStreamHome() {
      if (!chatStream) return;
      var welcome = !hasMessages && chatEmpty && chatEmpty.parentNode === chatStream && !(_idCard && _idCard.parentNode);
      chatStream.scrollTop = welcome ? 0 : chatStream.scrollHeight;
    }

    /* ── Panel open/close ────────────────────────────────── */
    function openPanel()  {
      panel.classList.add('is-open');
      backdrop.classList.add('is-open');
      launcher.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('klc-panel-open');
      // Mobile: the panel is a full-screen sheet — same scroll lock as ⤢.
      if (isFull() || IS_M) document.documentElement.classList.add('klc-full-open');
      if (IS_M) trackViewport(true);
      // Messages open at the bottom; the welcome screen at its top (scrollStreamHome).
      scrollStreamHome();
      loadCrisp(function () {
        hydrateFromCrisp();
        if (hasMessages && !_visitorPushed) pushVisitorFacts();
        scrollStreamHome();
        // No auto-focus on phones: the keyboard would cover the quick actions.
        if (!IS_M) setTimeout(function () { chatInput && chatInput.focus(); }, 250);
      });
    }
    function closePanel() {
      if (rec) stopRecording('cancel');
      panel.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      launcher.setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('klc-full-open');
      document.documentElement.classList.remove('klc-panel-open');
      if (IS_M) trackViewport(false);
      try { sessionStorage.removeItem(KLC_FULL_KEY); } catch (e) {}
      if (isFull()) panel.classList.remove('is-full');
    }
    function togglePanel() {
      panel.classList.contains('is-open') ? closePanel() : openPanel();
    }
    function openFull() { if (!IS_M) setFull(true); openPanel(); }

    /* Mobile keyboard: iOS keeps the layout viewport and shrinks only the
       visual one, so a 100dvh sheet would put the composer under the keyboard.
       While open, the sheet follows window.visualViewport (height + offset). */
    var _vvOn = false;
    function _vvApply() {
      var vv = window.visualViewport;
      if (!vv) return;
      panel.style.setProperty('--klc-vh', Math.round(vv.height) + 'px');
      panel.style.setProperty('--klc-vtop', Math.round(vv.offsetTop) + 'px');
    }
    function trackViewport(on) {
      var vv = window.visualViewport;
      if (!vv || on === _vvOn) return;
      _vvOn = on;
      if (on) {
        _vvApply();
        vv.addEventListener('resize', _vvApply);
        vv.addEventListener('scroll', _vvApply);
      } else {
        vv.removeEventListener('resize', _vvApply);
        vv.removeEventListener('scroll', _vvApply);
        panel.style.removeProperty('--klc-vh');
        panel.style.removeProperty('--klc-vtop');
      }
    }

    /* ── Wiring ──────────────────────────────────────────── */
    launcher.addEventListener('click', togglePanel);
    closeBtn.addEventListener('click', closePanel);
    backdrop.addEventListener('click', function () { if (!isFull()) closePanel(); });
    if (headerMenu) headerMenu.addEventListener('click', openMenu);
    if (headerBack) headerBack.addEventListener('click', subViewBack);
    if (headerNew)  headerNew.addEventListener('click', requestNewConversation);
    if (histNew)    histNew.addEventListener('click', requestNewConversation);
    if (headerHist) headerHist.addEventListener('click', function () {
      if (panel.classList.contains('is-history')) historyBack(); else openHistory();
    });
    if (headerFull) headerFull.addEventListener('click', function () { setFull(!isFull()); });
    if (histClear)  histClear.addEventListener('click', histClearAll);
    if (confirmYes) confirmYes.addEventListener('click', function () { closeConfirm(); startNewConversation(); });
    if (confirmNo)  confirmNo.addEventListener('click', closeConfirm);
    if (confirmBox) confirmBox.addEventListener('click', function (e) { if (e.target === confirmBox) closeConfirm(); });

    if (chatInput) {
      chatInput.addEventListener('input', function () {
        chatSend.disabled = !chatInput.value.trim();
        autoSize();
      });
      chatInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && !e.shiftKey) {
          e.preventDefault();
          sendMessage();
        }
      });
    }
    if (chatSend) chatSend.addEventListener('click', sendMessage);

    if (chatAttach && chatFile && KLC_UPLOAD_URL) {
      chatAttach.addEventListener('click', function () { chatFile.click(); });
      chatFile.addEventListener('change', function () {
        var files = chatFile.files ? Array.prototype.slice.call(chatFile.files) : [];
        files.forEach(handleFilePick);
        chatFile.value = ''; // allow re-select of same files
      });
    } else if (chatAttach) {
      // Anders als das Mikrofon steht dieser Knopf sichtbar im Markup, muss
      // hier also aktiv weg. Das traegt .klc [hidden] { display:none
      // !important } in karinex-live-chat.css — ohne dieses !important wuerde
      // .klc-chat-attach { display:flex } gewinnen. Nicht "aufraeumen".
      chatAttach.hidden = true;
    }

    // Lightbox controls
    if (lightboxX) lightboxX.addEventListener('click', closeLightbox);
    if (lightbox)  lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (lightbox && lightbox.classList.contains('is-open')) { closeLightbox(); return; }
      if (confirmBox && !confirmBox.hidden) { closeConfirm(); return; }
      if (rec) { stopRecording('cancel'); return; }
      if (!panel.classList.contains('is-open')) return;
      if (panel.classList.contains('is-history'))   historyBack();
      else if (panel.classList.contains('is-menu')) closeSubViews();
      else if (isFull())                            setFull(false);
      else                                          closePanel();
    });

    // ── Proactive teaser card ─────────────────────────────────────
    // Shows once per 24 hours, ~4 s after load, auto-collapses after 30 s
    // back to the compact launcher pill. Honest-hours gate: only rendered
    // 08:00–22:59 Europe/Berlin (staffed support window — never claim
    // "online" at night). The 24 h stamp is set when the card is SHOWN,
    // so X / "Danke – gerade nicht" / auto-collapse all behave the same.
    var card        = document.getElementById('klcCard');
    var cardChat    = document.getElementById('klcCardChat');
    var cardCall    = document.getElementById('klcCardCall');
    var cardDismiss = document.getElementById('klcCardDismiss');
    var cardX       = document.getElementById('klcCardX');
    var cardHideTimer = null;

    /* Frequency rule (merchant 2026-08-12) — the card should reach customers
       more often than the old once-per-24-h-per-device flag allowed:
         • closes the browser and comes back  → shows again (sessionStorage is
           wiped when the browser session ends)
         • opens the shop in another browser  → shows (separate storage)
         • keeps the same session open        → shows again after 12 h
       sessionStorage alone expresses all three: an empty marker means "new
       session, show it", and within a session the 12 h stamp throttles it.
       (The old localStorage key klc_card_last_shown_at is no longer read; any
       leftover value is simply ignored.) */
    var KLC_CARD_KEY = 'klc_card_seen_at';
    var KLC_CARD_REPEAT_MS = 12 * 60 * 60 * 1000;

    function klcCardSuppressed() {
      try {
        var raw = sessionStorage.getItem(KLC_CARD_KEY);
        if (raw === null) return false;            // new browser session → show
        var at = parseInt(raw, 10);
        if (at && (Date.now() - at) < KLC_CARD_REPEAT_MS) return true;
      } catch (e) { /* storage unavailable → just show */ }
      return false;
    }

    function klcHideCard() {
      // Always bring the launcher back, even if the card never made it in.
      klcRoot.classList.remove('klc--card-stage');
      if (!card || card.hidden) return;
      if (cardHideTimer) { clearTimeout(cardHideTimer); cardHideTimer = null; }
      card.classList.remove('is-in');
      setTimeout(function () { card.hidden = true; }, 500);
    }

    /* Preview override: append ?klc_card=1 to any URL to see the proactive
       card immediately, ignoring both the 08:00–23:00 window and the 24 h
       once-per-visitor suppression. Nothing else changes — it renders exactly
       as a real visitor sees it — and the "last shown" flag is NOT written, so
       it can be re-opened as often as needed. Added for the merchant, who
       could not review the card at night (2026-08-12). */
    var klcForceCard = /[?&]klc_card=1(?:&|$)/.test(window.location.search);
    var cardWillShow = !!card && !IS_M && (klcForceCard ||
      (cardHour >= 8 && cardHour < 23 && !klcCardSuppressed()));

    if (cardWillShow) {
      // Hide the launcher from the start so it doesn't flash in and out
      // before the card appears — the card takes the stage alone.
      klcRoot.classList.add('klc--card-stage');
      setTimeout(function () {
        if (panel.classList.contains('is-open')) { klcRoot.classList.remove('klc--card-stage'); return; }
        if (!klcForceCard) {
          try { sessionStorage.setItem(KLC_CARD_KEY, String(Date.now())); } catch (e) {}
        }
        card.hidden = false;
        // double rAF so the entry transition actually runs
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { card.classList.add('is-in'); });
        });
        cardHideTimer = setTimeout(klcHideCard, 30000);
      }, 4000);
    }
    if (card) {
      if (cardChat) cardChat.addEventListener('click', function () {
        klcHideCard();
        openPanel();
      });
      if (cardCall) cardCall.addEventListener('click', function () { klcHideCard(); });
      if (cardX) cardX.addEventListener('click', klcHideCard);
      if (cardDismiss) cardDismiss.addEventListener('click', klcHideCard);
      launcher.addEventListener('click', klcHideCard);
    }

    // Teaser briefly after load (skipped when the proactive card takes the stage).
    // Same 08:00–23:00 Berlin window as the card: the teaser literally says
    // "Wir sind online – Antwort in ca. 2 Min." and must never claim staffed
    // support outside the published service hours (CLAUDE.md §9.23 — the same
    // UWG discipline as the fake-countdown and fake-review bans). Outside the
    // window the launcher still works; visitors just aren't promised a live
    // reply. Merchant screenshot 2026-08-12 showed the teaser at 23:22.
    if (!cardWillShow && !IS_M && cardHour >= 8 && cardHour < 23) {
      setTimeout(function () {
        if (!panel.classList.contains('is-open')) {
          launcher.classList.add('klc-show-teaser');
          setTimeout(function () { launcher.classList.remove('klc-show-teaser'); }, 4200);
        }
      }, 2500);
    }

    // Full-screen chat survives a page change within the session (⤢ was the
    // visitor's explicit choice); the compact panel does not reopen by itself.
    try {
      if (!IS_M && sessionStorage.getItem(KLC_FULL_KEY) === '1') { klcHideCard(); openFull(); }
    } catch (e) {}

    // Crisp sets its own cookies and contacts crisp.chat, so it may only load
    // (§ 25 TDDDG, 25.09.2026):
    //   • once the visitor has consented — Cookiebot preferences, the banner's
    //     "Crisp Live-Chat" switch (other.live_chat) or "Alles akzeptieren";
    //   • when the visitor opens the chat himself (openPanel → loadCrisp) — a
    //     service he explicitly requested (§ 25 Abs. 2 Nr. 2 TDDDG);
    //   • when he had a conversation before (klc_id_session / klc_wait) — he
    //     requested the chat earlier and waits for replies.
    // Pre-warming on idle is only a speed-up for the first send. Mobile keeps
    // the stricter #1202 rule: earlier conversation only (performance).
    // 02.10.2026: der eigene Schalter "Crisp Live-Chat" im Banner entscheidet
    // ZUERST. Cookiebot kennt nur Kategorien: ein Haken bei Vimeo setzte bisher
    // "preferences" und lud damit auch Crisp vor. Seit dem Banner-Fix schreiben
    // "Alles akzeptieren/ablehnen" alle Einzelschalter, der Schalter ist also
    // immer aktuell. Cookiebot nur noch, wenn es keine Einzelauswahl gibt.
    function chatConsented() {
      try {
        var raw = localStorage.getItem('karinex_cookie_settings');
        if (raw) {
          var st = JSON.parse(raw);
          if (st && st.other && typeof st.other.live_chat === 'boolean') return st.other.live_chat;
        }
      } catch (e) {}
      try {
        if (window.Cookiebot && window.Cookiebot.consent && window.Cookiebot.hasResponse) return window.Cookiebot.consent.preferences === true;
      } catch (e) {}
      try {
        return localStorage.getItem('karinex_cookie_consent') === 'accepted';
      } catch (e) { return false; }
    }
    function hadConversation() {
      try { return !!(localStorage.getItem('klc_id_session') || localStorage.getItem('klc_wait')); } catch (e) { return false; }
    }
    var idlePrewarm = function () {
      if (crispLoaded) return;
      if (!hadConversation() && (IS_M || !chatConsented())) return;
      if ('requestIdleCallback' in window) {
        requestIdleCallback(function () { loadCrisp(); }, { timeout: 8000 });
      } else {
        setTimeout(function () { loadCrisp(); }, 6000);
      }
    };
    if (document.readyState === 'complete') idlePrewarm();
    else window.addEventListener('load', idlePrewarm);
    // Consent given during this visit → pre-warm now instead of on the next page.
    window.addEventListener('CookiebotOnAccept', function () { setTimeout(idlePrewarm, 0); });
    // Fallback when Cookiebot itself is blocked (ad blocker): any button in our
    // banner or its settings dialog re-checks the stored choice.
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('#kxCookieBanner button, #kxCookieSettingsModal button')) setTimeout(idlePrewarm, 400);
    }, true);

    window.KarinexChat = {
      open:         openPanel,
      close:        closePanel,
      toggle:       togglePanel,
      openLiveChat: openPanel,
      openChatDirect: openPanel,
      openFull:     openFull,
      closeFull:    function () { setFull(false); },
      openHistory:  function () { openPanel(); openHistory(); },
      newConversation: function () { openPanel(); requestNewConversation(); }
    };
  })();
